import { Audio } from '@abcya/abcya_phaser';

export default class AudioPlayer {
  static get sounds() {
    return {
      CLICK: 'click',
      CORRECT_METEOR: 'correct_meteor',
      INCORRECT_METEOR: 'incorrect_meteor',
      DOOR_CLOSE: 'door_close',
      DOOR_OPEN: 'door_open',
      JINGLE: 'jingle',
      METEOR_EXPLOSION: 'meteor_explosion',
      ROCKET_BLAST_OFF: 'rocket_blast_off',
      SELECT_METEOR: 'select_meteor',
      CLICK_METEOR: 'Click_on_the_meteors',
      DRAG_SPACE_ROCKS: 'Drag_the_space_rocks',
      CHOOSE_NUMBER: 'Choose_a_Number_to_Count_By',
      YOU_ARE_AMAZING: 'Out_of_this_World'
    };
  }

  static PlaySound(scene, sound, loop = false, volume = .5, audioSprite = Audio.DEFAULT_AUDIO_SPRITE) {
    const soundClip = Audio.playOneShot(sound, scene, volume, loop, 0, audioSprite);
    return soundClip;
  }
}